<template>
  <div class="overlay">
      <div class="tile is-ancestor">
        <div class="tile is-vertical is-12">
          <div class="tile">
            <div class="tile is-parent is-horizontal is-6 top-row">
              <div class="tile is-child">
                <h1>{{ $t('quote.text') }}</h1>
                <p class="authorC">- Epictetus.</p>
              </div>
            </div>
            <div class="tile is-parent is-horizontal is-6 top-row">
              <div class="tile is-child">
                <Transcript/>
              </div>
            </div>
          </div>
          <div class="tile">
            <div class="tile is-parent is-horizontal is-12">
              <div class="tile is-child bottom-grow">
                <DailyChart class="pointer-events-enabled"/>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import Transcript from './shared/Transcript.vue';
import DailyChart from './charts/TotalDailyChart.vue';

export default {
  name: 'Overlay',
  components: {
    DailyChart,
    Transcript,
  },
  data() {
    return {
    };
  },
};
</script>

<style scoped>
.overlay {
  position: absolute;
  z-index: 2;
  width: 100vw;
  height: calc(100vh - 3.25rem);
  pointer-events: none;
  top: 3.25rem;
}

  .overlay section {
    margin-top: 4.25rem;
  }

  h1 {
    color: white;
    font-size: large;
  }

  .authorC {
    color: #6382a0;
  }

  .bottom {
    height: 100%;
    display: flex;
  }

  .bottom div {
    align-self: flex-end
  }

  .tile.is-ancestor {
    height: 100%;
  }

  .container {
    height: 100%;
    /*padding: 3.25rem 25px 0px;*/
  }

  .citation {
    padding-top: 50px !important;
  }


.pointer-events-enabled{
  pointer-events: all;
}
  .c1 {
    padding-left: 50px;
  }

  .bottom-grow{
    display: flex;
    justify-content: flex-end;
  }
  .is-ancestor{
    padding: 30px 25px 0px 25px;
  }
  .top-row{
    margin-top: 20px;
  }
</style>
